// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bluetooth';

export const Component = () => (
  <path d='m20.475 16.762-6.897-4.74 6.897-4.742a.502.502 0 0 0 .24-.432c0-.143-.049-.239-.192-.382L12.668.096C12.524.048 12.428 0 12.38 0c-.335 0-.526.144-.526.479v10.344L4.766 5.986a.367.367 0 0 0-.24-.096c-.335 0-.526.144-.526.479 0 .191.096.335.24.383l7.614 5.268-7.615 5.22a.502.502 0 0 0-.239.43c0 .335.191.479.527.479.047 0 .143-.048.287-.096l7.04-4.885V24.04c0 .335.192.479.527.479.096 0 .192-.048.288-.144l7.854-6.849c.144-.143.192-.239.192-.382 0-.144-.096-.288-.24-.383Zm-7.616-5.46v-9.77l6.514 5.316-6.514 4.454Zm6.562 5.892-6.56 5.747V12.69l6.56 4.502Z' />
);

export const viewBox = '0 0 25 25';
